import React, { useState, useEffect } from "react";
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga";
import { function_VEN_Reservas_Cabecera_Leer, function_VEN_Reservas_Cabecera_MarcaDeEvento, function_VEN_Reservas_Cabecera_QuitarMarcaDeEvento } from "neftis7_apicaller/src/funciones/VEN/Reservas/VEN_Reservas_Cabecera";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import LVButtonReporte from "../../Componentes/Basicos/LVButtonReporte";
import { DateBox, NumberBox } from "devextreme-react";
import { VEN_Reservas_ParticipantesPorItem } from "../../Componentes/Compuestos/Complejos/Operaciones/VEN_Reservas_ParticipantesPorItem";
import { LVForm } from "../../Componentes/Basicos/LVForm";
import { SimpleItem } from "devextreme-react/form";
import { FormateoFechaPara_ddMMyyyy_HHmm } from "neftis7_apicaller/src/funciones/Varios";
import { useParams } from "react-router-dom";
import { VEN_Reservas_ModificarFechaPorArticulo } from "../../Componentes/Compuestos/Complejos/Operaciones/VEN_Reservas_ModificarFechaPorArticulo";

export const VEN_Reservas_ModificarFecha = () => {
  const [loading, setLoading] = useState(false)
  const [idReserva, setIdReserva] = useState(0);
  const [esEvento, setEsEvento] = useState(false);
  const [idClienteResponsable, setIdClienteResponsable] = useState(0);
  const [reserva, setReserva] = useState([]);
  const [detalles, setDetalles] = useState([]);
  const params = useParams();
  const [fechaSeleccionada, setFechaSeleccionada] = useState(new Date());

  useEffect(() => {
    if (params?.idReserva) {
      setIdReserva(Number(params.idReserva));
      handleBuscarReserva(Number(params.idReserva));
    }
  }, [params]);

  const handleIdReservaOnValueChanged = (e) => {
    setIdReserva(e.value)
  }

  const handleBuscarReserva = async (idReserva) => {
    try {
      if (!idReserva || idReserva < 1) {
        setReserva([]);
        setDetalles([]);
        setIdClienteResponsable(0);
        setIdReserva(0)
        alert("Para buscar necesita ingresar una reserva con número válido.");
        return;
      }

      setLoading(true);
      const resultReserva = await function_VEN_Reservas_Cabecera_Leer(idReserva);

      if (resultReserva.data.IdEstado == 50) {
        setReserva([]);
        setDetalles([]);
        setIdClienteResponsable(0);
        setIdReserva(0)
        alert("Para buscar necesita ingresar una reserva facturada.");
        return;
      }

      if (resultReserva.data.IdEstado == -10) {
        setReserva([]);
        setDetalles([]);
        setIdClienteResponsable(0);
        setIdReserva(0)
        alert("Para buscar necesita ingresar una reserva que no se encuentre anulada.");
        return;
      }

      setEsEvento(resultReserva.data.EsEvento)
      setReserva(resultReserva.data || []);
      setDetalles(resultReserva.data.Detalles || []);
      setIdClienteResponsable(resultReserva.data.IdClienteGenerador);
    } catch (error) {
      alert("Hubo problemas con la Reserva.");
    } finally {
      setLoading(false);
    }
  };

  const handleOnClick_QuitarMarcaEvento = async () => {
    try {
      if (!idReserva || idReserva < 1) {
        alert("Necesita ingresar una reserva con número válido.");
        return;
      }

      await function_VEN_Reservas_Cabecera_QuitarMarcaDeEvento(idReserva)

      handleBuscarReserva(idReserva)
    } catch (error) {
      alert("Hubo problemas al modificar la Reserva.");
    } finally {
      setLoading(false);
    }
  };

  const handleOnClick_MarcaEvento = async () => {
    try {
      if (!idReserva || idReserva < 1) {
        alert("Necesita ingresar una reserva con número válido.");
        return;
      }

      await function_VEN_Reservas_Cabecera_MarcaDeEvento(idReserva)
      
      handleBuscarReserva(idReserva)
    } catch (error) {
      alert("Hubo problemas al modificar la Reserva.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PaginaCarga Titulo="MODIFICACIÓN DE FECHA">
      <div className="LV-FlexContainer" style={{ marginBottom: "20px", gap: "20px" }}>
        <NumberBox
          label="Reserva"
          value={idReserva}
          width={120}
          onValueChanged={handleIdReservaOnValueChanged}
          style={{ flex: 1, marginRight: '10px' }}
        />

        <LVButtonAccion
          Texto="BUSCAR"
          Ancho={200}
          onClick={() => handleBuscarReserva(idReserva)}
          style={{ flex: 1 }}
        />

        <LVButtonAccion
          Texto="QUITAR MARCA DE EVENTO"
          Ancho={300}
          visible={esEvento && idReserva > 0}
          onClick={handleOnClick_QuitarMarcaEvento}
          style={{ flex: 1 }}
        />

        <LVButtonAccion
          Texto="MARCA DE EVENTO"
          Ancho={200}
          visible={!esEvento && idReserva > 0}
          onClick={handleOnClick_MarcaEvento}
          style={{ flex: 1 }}
        />
      </div>

      <div className="LV-FlexContainer" style={{ gap: "20px", alignItems: "center" }}>
        <h5>Nueva fecha para todas las actividades</h5>
        <DateBox
          displayFormat="dd/MM/yyyy"
          value={fechaSeleccionada}
          onValueChanged={(e) => setFechaSeleccionada(e.value)}
          width={120}
        />
      </div>

      <div>
        <hr style={{ borderColor: 'white', borderWidth: '1px' }} />

        {loading ? (
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        ) : (
          Array.isArray(detalles) && detalles.length > 0 ? (
            detalles.map((articulo, index) => (
              <div key={articulo.IdItem}>
                <h5>Actividad: {articulo.Articulo} - Cantidad: {articulo.CantidadParticipantes} - Cargados: {articulo.CantidadParticipantesCargados} - Inicio: {FormateoFechaPara_ddMMyyyy_HHmm(new Date(articulo.FechaReservaInicio))}</h5>

                <VEN_Reservas_ModificarFechaPorArticulo
                  key={articulo.Identificador}
                  Identificador={articulo.Identificador}
                  Fecha={fechaSeleccionada}
                  CodigoArticulo={articulo.CodigoArticulo}
                  Cantidad={articulo.CantidadParticipantes}
                  dataDetalles={detalles}
                  IdItem={articulo.IdItem}
                  IdReserva={idReserva}
                  SetDataDetalles={setDetalles}
                />

                <hr style={{ borderColor: 'white', borderWidth: '1px' }} />
              </div>
            ))
          ) : (
            <div>La Reserva no existe.</div>
          )
        )}
      </div>

      <LVForm colCount={10}>
        <SimpleItem colSpan={10}>
          <LVButtonReporte Ancho="100%" Texto="IR A PUNTO DE VENTA" Url={`/VEN_PuntoDeVenta_/${localStorage.getItem("Terminal")}`} />
        </SimpleItem>
      </LVForm>
    </PaginaCarga>
  );
};
